import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DynamicOutput } from '../models/modal.model';
import { ModalComponentKey, modalComponentRegistry } from './modal-component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private output = new Subject<DynamicOutput>();

  constructor() {}

  getObservable() {
    return this.output.asObservable();
  }

  outputFromDynamicComponent(id: number, data: string) {
    this.output.next({ id: id, data: data });
  }

  getComponentClass(key: ModalComponentKey) {
    return modalComponentRegistry.get(key);
  }

  resetFromDynamicComponent() {
    // this.output.next({ id: -1, data: '-1' });
  }
}
